// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes bounceIn--nBezn {
  0% {
    height: 1rem;
  }

  50% {
    height: 3rem;
  }

  100% {
    height: 1rem;
  }
}

.inlineLoading--cWqt5 {
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--color_white-with-opacity);
  z-index: 50;
  height: 100%;
  min-height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.loadingBar--TaxHN {
  width: 0.5rem;
  height: 1rem;
  margin: 0.25rem;
  border-radius: 1rem;
  background-color: #2f2965;
}

.animated--g7yMs {
  animation: bounceIn--nBezn 1s 0s infinite;
  background-color: var(--color_orange-tangerine);
}
`, "",{"version":3,"sources":["webpack://./src/common/components/loading-indicator/loading-indicator.css"],"names":[],"mappings":"AAAA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,iDAAiD;EACjD,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yCAAkC;EAClC,+CAA+C;AACjD","sourcesContent":["@keyframes bounceIn {\n  0% {\n    height: 1rem;\n  }\n\n  50% {\n    height: 3rem;\n  }\n\n  100% {\n    height: 1rem;\n  }\n}\n\n.inlineLoading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: var(--color_white-with-opacity);\n  z-index: 50;\n  height: 100%;\n  min-height: 60px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.loadingBar {\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.25rem;\n  border-radius: 1rem;\n  background-color: #2f2965;\n}\n\n.animated {\n  animation: bounceIn 1s 0s infinite;\n  background-color: var(--color_orange-tangerine);\n}\n"],"sourceRoot":""}]);
// Exports
export var inlineLoading = `inlineLoading--cWqt5`;
export var loadingBar = `loadingBar--TaxHN`;
export var animated = `animated--g7yMs`;
export var bounceIn = `bounceIn--nBezn`;
export default ___CSS_LOADER_EXPORT___;
